import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { DialogService } from 'src/app/shared/dialogs/services/DialogService';
import { LabelService } from 'src/app/shared/framework/labels/services/label.service';

@Injectable({
  providedIn: 'root',
})
export class ELearningService implements OnInit, OnDestroy {
  private courseBox: Window;
  private timer: Subscription;
  private title: string;
  private message: string;

  public constructor(
    private dialog: DialogService,
    private _labelService: LabelService,
    private http: HttpClient
  ) {
  }
  ngOnInit() {
  }

  public startScorm2(
    title,
    message,
    action,
    confirm,
    televic,
    televicpublicationid,
    onStarted?: () => void,
    onCancelled?: () => void
  ) {
    let varTelevic = televic;

    if (televicpublicationid === undefined) {
    }

    let screenWidth = screen.width;
    let screenHeight = screen.height;
    if (screenWidth === 0) {
      screenWidth = 1024;
    }
    if (screenHeight === 0) {
      screenHeight = 768;
    }

    if (confirm === 'yes') {
      this.dialog
        .confirm({
          title: title,
          message: message,
        })
        .then(
          () => {
            if (onStarted) {
              onStarted();
            }
            this.openScormOverlayer(action, varTelevic);
          },
          () => {
            if (onCancelled) {
              onCancelled();
            }
          }
        );
    } else {
      if (onStarted) {
        onStarted();
      }
      this.openScormOverlayer(action, varTelevic);
    }
    return false;
  }
  private _subscriptions: Subscription[] = [];
  ngOnDestroy(): void {
    for (const subscription of this._subscriptions) {
      subscription.unsubscribe();
    }
  }

  public startScorm(
    participantID,
    studentID,
    tvCourseID,
    isRegistered,
    televic,
    coursename: string,
    studentActivityId?: number,
    learningPathId?: number,
    onStarted?: () => void,
    onCancelled?: () => void
  ) {
    if (televic === undefined) {
      televic = false;
    }

    /*const title = '';
    const message = '' + coursename + ' ?';*/
    // alert(title);
    //alert(message);
    this._subscriptions.push(
      this._labelService
        .getLabel('confirmationtitle', 'elearningregister', false)
        .subscribe((label) => {
          this.title = label.labelText;
          this._subscriptions.push(
            this._labelService
              .getLabel('sureelearningregister', 'elearningregister', false)
              .subscribe((label) => {
                this.message = label.labelText;
                var titlebox = this.title;
                var messagebox = this.message + coursename + '?';

                if (isRegistered === 'yes') {
                  const action =
                    '../../../../PerfNav/elearning/elearningopener.asp?participant=' +
                    participantID +
                    '&student=' +
                    studentID +
                    '&tvcourse=' +
                    tvCourseID +
                    '&registered=' +
                    (isRegistered || '') +
                    '&activityid=' +
                    (studentActivityId || '') +
                    '&learnpath=' +
                    (learningPathId || '') +
                    '&foreval=';
                  this.startScorm2(
                    titlebox,
                    messagebox,
                    action,
                    'no',
                    televic,
                    tvCourseID,
                    onStarted,
                    onCancelled
                  );
                } else {
                  const action =
                    '../../../../PerfNav/elearning/elearningopener.asp?participant=' +
                    participantID +
                    '&student=' +
                    studentID +
                    '&tvcourse=' +
                    tvCourseID +
                    '&registered=' +
                    (isRegistered || '') +
                    '&activityid=' +
                    (studentActivityId || '') +
                    '&learnpath=' +
                    (learningPathId || '') +
                    '&foreval=';
                  this.startScorm2(
                    titlebox,
                    messagebox,
                    action,
                    'yes',
                    televic,
                    tvCourseID,
                    onStarted,
                    onCancelled
                  );
                }
              })
          );
        })
    );
  }

  public lockHomeScreen() {
    document
      .getElementById('learningPlan')
      .setAttribute('src', '/PerfNav/student/ML/adm/inProgress.asp?nofresh=1');

    document
      .getElementById('overlaywrapper')
      .setAttribute('style', 'display:block');
  }

  public openPopUp(action) {
    const scrWidth = screen.width;
    const scrHeight = screen.height;

    this.courseBox = window.open(
      action + '&sid=',
      'win',
      'width=' +
      scrWidth +
      ',height=' +
      scrHeight +
      ',toolbar=0,location=0,directories=0,status=0,titlebar=0,menubar=0,scrollbars=0,resizable=0,top=0,left=0'
    );
  }

  public openScormOverlayer(action, televicparameter) {
    const scrWidth = screen.width;
    const scrHeight = screen.height;

    this.courseBox = window.open(
      action + '&sid=',
      'win',
      'width=' +
      scrWidth +
      ',height=' +
      scrHeight +
      ',toolbar=0,location=0,directories=0,status=0,titlebar=0,menubar=0,scrollbars=0,resizable=0,top=0,left=0'
    );

    const a = timer(2000, 5000);
    this.timer = a.subscribe(() => {
      const canRefresh = this.courseBox == null || this.courseBox.closed;

      if (canRefresh) {
        try {
          document
            .getElementById('learningPlan')
            .setAttribute(
              'src',
              '/PerfNav/student/ML/adm/inProgress.asp?removeticket=yes'
            );
          this.timer.unsubscribe();
          window.location.reload();
        } catch (e) {
          // alert(e.message);
          console.error(e);
        }
      }
    });

    if (this.courseBox) {
      this.courseBox.onbeforeunload = () => {
        document
          .getElementById('learningPlan')
          .setAttribute(
            'src',
            '/PerfNav/student/ML/adm/inProgress.asp?removeticket=yes'
          );
        this.timer.unsubscribe();
        window.location.reload();
      };
    }

    if (televicparameter === undefined) {
      televicparameter = false;
    }

    if (televicparameter) {
      if (window.addEventListener) {
        window.addEventListener(
          'message',
          this.receiveMessage.bind(this),
          false
        );
      } else {
        (<any>window).attachEvent('onmessage', this.receiveMessage.bind(this));
      }
    }

    this.lockHomeScreen();
  }

  private receiveMessage(e: any) {
    if (e.data === 'playerfinished' || e.message === 'playerfinished') {
      this.http
        .post('/PerfNav/elearning/televicprocessor.asp', null, {})
        .subscribe();
    }
  }
}
